import React, { useState, useEffect,useRef} from 'react'
import Button from 'react-bootstrap/Button';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import { SlDrawer, SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useSelector } from 'react-redux';
import { roles } from "../../utils/constants";
import { useForm } from "react-hook-form";
import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton, SlOption, SlSelect } from '@shoelace-style/shoelace/dist/react';
import * as XLSX from 'xlsx';
import { formatDate, formatDateWithTime, formatDateYYYYMMDD } from "../../utils/dateFormat";
import Datepicker from "react-tailwindcss-datepicker";
import { CSVLink } from "react-csv";
import NoImage from "../../assets/images/NoImage.png";
import EditIcon from "../../assets/images/edit_icon.svg";
import UserIcon from "../../assets/images/user_icon.svg";
import LocationSVG from "../../assets/images/location.svg";
import InfiniteScroll from 'react-infinite-scroll-component';
import { Modal } from "react-bootstrap";
import filterSvg from '../../assets/images/filter.svg'
import Select from 'react-select'
const initialContacts = {
    name: '',
    designation: '',
    official_email: '',
    personal_email: '',
    mobile: '',
    company: '',
    location: '',
    category: '',
    source: '',
    date: '',
    image_url: ''

}

let initialValues = JSON.parse(JSON.stringify(initialContacts));

const ContactsSchema = Yup.object().shape({
    name: Yup.string().matches(/^[a-zA-Z0-9\s.&]*$/, "Name can't start with white space and must contain only alphabets").nullable(),
    official_email: Yup.string().email().nullable(),
    personal_email: Yup.string().email().nullable(),
    mobile: Yup.string().nullable().matches(/^(?:(?:\+\d{1,3}\s?)?(\d{10})|(?:0\d{1,5}\s?(\d{6,8}))|(\d+))$/, "Enter valid mobile Number"),
    location: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Location can't start with white space and must contain only alphabets").nullable(),
    source: Yup.string().matches(/^[a-zA-Z0-9-]*$/, "Source must Alphanumeric").required("Please enter the Source"),
    company: Yup.string().matches(/^(?!\s)[a-zA-Z0-9\s]*$/, "Company must be Alphanumeric").required(),
    category: Yup.string().matches(/^(?!^\s)[a-zA-Z0-9\s@%$&*():;"'/+=\-_.,|]+$/, "Category must have only alphabets").nullable(),
    designation: Yup.string().matches(/^(?!^\s)[a-zA-Z0-9\s@%$&*():;"'/+=\-_.,|]+$/, "Enter valid designation").nullable(),
    date: Yup.date().required("Please select the date"),

})

function CompetitorData() {
    const navigate = useNavigate();
    const [dateFilter, setDateFilter] = useState("")
    const [image, setImage] = useState("")

    const [delId, setDelId] = useState(-1);
    const [delname, setDelname] = useState("")
    const [del, setDel] = useState(false);
    const [data, setData] = useState([]);
    const [downloadData, setDownloadData] = useState([])
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [flag, setFlag] = useState('')
    const [id, setId] = useState('');
    const [search, setSearch] = useState("")
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [userId, setuserId] = useState("")
    const [contactId, setContactId] = useState("")
    const [requestStatus, setRequestStatus] = useState("")
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });
    const [selectedRecords, setSelectedRecords] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [clickindex, setClickIndex] = useState(-1)
    const [open, setOpen] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [source, setSource] = useState("All");
    const [sources, setSources] = useState([]);
    const [view, setView] = useState(false);
    const [imgSrc, setImgSrc] = useState("");
    const [advDetails, setAdvDetails] = useState([]);
    const [preview, setPreview] = useState(false)
    const [fileUrl, setFileUrl] = useState("")
    const [showFilter,setShowFilter] = useState(false)
    const [brands, setBrands] = useState([]);

    const [showMagnifier, setShowMagnifier] = useState(false);
    const [position, setPosition] = useState({ x: 50, y: 50 });
    const imgRef = useRef(null);
  
    const zoomLevel = 5;
  
    const handleMouseMove = (e) => {
      const elem = imgRef.current;
      if (!elem) return;
  
      const { top, left, width, height } = elem.getBoundingClientRect();
      const x = ((e.pageX - left - window.pageXOffset) / width) * 100;
      const y = ((e.pageY - top - window.pageYOffset) / height) * 100;
  
      // Allow zooming even beyond edges (0-100% can become negative or >100%)
      setPosition({ x, y });
    };

    const toggleCheckbox = (recordId) => {
        if (selectedRecords.includes(recordId)) {
            setSelectedRecords(selectedRecords.filter((id) => id !== recordId));
        } else {
            setSelectedRecords([...selectedRecords, recordId]);
        }
    };

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectedRecords([]);
        } else {
            const pageRecordIds = data.map((item) => item.contact_id);
            setSelectedRecords(pageRecordIds);
        }
        setSelectAll(!selectAll);
    };
    const handleDateRange = (selectedDate) => {
        setData([]);
        setCurrentPage(0)
        if (selectedDate) {
            if (selectedDate.startDate && selectedDate.endDate) {
                setDateRange(selectedDate);
            } else {
                setDateRange({ startDate: null, endDate: null });
            }
        } else {
            setDateRange({ startDate: null, endDate: null });
        }
    }

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        loadData(search, event.selected, dateRange, source);
        downloadCompetitorContacts(search, dateRange, source);
    };

    const handleClose = () => {
        setShow(false);
        setSubmit(false);
        initialValues = JSON.parse(JSON.stringify(initialContacts));
        formik.setValues(initialValues);
    };

    const handleOpen = () => {
        setOpen(true);
    };
    const loadSources = async () => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            setLoader(true);
            const response = await api({
                url: `/competitor_data/sources`,
                method: "POST",
                responseType: "json"
            });
            if (response?.code === 200) {
                setSources(response?.data?.result);
                setLoader(false);
            }
            else {
                toast.error(response?.data?.message);
                setLoader(false)
            }
        }
    };

    const imageData = async (id) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            setLoader(true);
            const response = await api({
                url: `/competitor_data/competitorImage`,
                method: "POST",
                responseType: "json",
                data: {
                    id: id
                }
            })
            if (response?.code !== 200) {
                toast.error(response?.data?.message);
                loadData(search, currentPage, dateRange, source);

            } else {
                window.open(response?.data?.result, '_blank');
                setImage(response?.data?.result)
                // setPreview(!preview);
                setLoader(false);
            }
        }
    }


    const driveImageData = async (id) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            setLoader(true);
            const response = await api({
                url: `/competitor_data/competitorDriveImage`,
                method: "POST",
                responseType: "json",
                data: {
                    id: id
                }
            })
            if (response?.code !== 200) {
                toast.error(response?.data?.message);
                loadData(search, currentPage, dateRange, source);
            } else {
                window.open(response?.data?.result, '_blank');
                setImage(response?.data?.result)
                // setPreview(!preview);
                setLoader(false);
            }
        }
    }



    const handleShow = (choose, item) => {
        if (choose === "add") {
            formik.setValues(item);
            setShow(true);
        }
        if (choose === 'edit') {
            if (item.name === "null") {
                initialValues.name = ''
            } else {
                initialValues.name = item.name

            }
            if (item.designation === "null") {
                initialValues.designation = ''
            } else {

                initialValues.designation = item.designation
            }
            if (item.official_email === "null") {
                initialValues.official_email = ''
            } else {

                initialValues.official_email = item.official_email
            } if (item.image_url === null) {
                initialValues.image_url = ''
            } else {
                initialValues.image_url = item.image_url
            }
            initialValues.personal_email = item.personal_email
            initialValues.mobile = item.mobile
            initialValues.company = parseInt(item.company)
            initialValues.location = item.location
            initialValues.category = item.category
            initialValues.source = item.source
            initialValues.image_url = item.image_url
            initialValues.date = formatDateYYYYMMDD(item.date)
            formik.setValues(initialValues);
            setShow(true)
        }
    };

    const getBrands = async (brandType, edition) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            let response = await api({
                url: `/birdview/birdview_brands`,
                method: "POST",
                responseType: "json",
                data: {
                    brand_type: brandType,
                    edition: edition
                }
            })
            if (response?.code !== 200) {
                toast.error(response?.data?.message);
            } else {
                setBrands(response?.data?.result)
            }
        }
    }

    // useEffect(() => {
    //     if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
    //         loadData(search, 0, dateRange);
    //         downloadCompetitorContacts(search, dateRange, source)
    //     }
    // }, []);

    useEffect(() => {
        loadData(search, 0, dateRange, source);
        downloadCompetitorContacts(search, dateRange, source)
    }, [contactId, dateRange, source, search]);

    useEffect(() => {
        loadSources();
        getBrands();
    }, []);

    const deleteContact = async (selectedRecords) => {
        try {
            let res = await api({
                url: `/competitor_data/deleteCompetitorData`,
                method: "DELETE",
                responseType: "json",
                data: { ids: selectedRecords }
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message);
                loadData(search, 0, dateRange, source);
            } else {
                toast.success("Contact Deleted Successfully");
                setCurrentPage(0);
                setSearch('');
                loadData(search, 0, dateRange, source);
                downloadCompetitorContacts(search, dateRange, source)
                loadSources();
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const loadData = async (searchString = '', page = 0, dateRange, source) => {
        try {
            if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
                if (data?.length === 0)
                    setLoader(true);
                let res = await api({
                    url: `/competitor_data/get`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        page,
                        limit: 10,
                        search: searchString,
                        dateRange,
                        source
                    }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    if (flag === "edit") {
                        setData(res?.data?.data);
                    } else {
                        setData([...data, ...res?.data?.data]);
                    }
                    // setData([...data, ...res?.data?.data]);
                    setuserId(res?.data?.user_id);
                    setTotalPages(Math.ceil(res?.data?.total / 10));
                    setTotalRecords(res?.data?.total)
                    // setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const csvHeaders = [
        { label: "Name", key: "Name" },
        { label: "Designation", key: "Designation" },
        { label: "Official_Email", key: "Official_Email" },
        { label: "Personal_Email", key: "Personal_Email" },
        { label: "Mobile", key: "Mobile" },
        { label: "Company_Name", key: "Company_Name" },
        { label: "Location", key: "Location" },
        { label: "Category", key: "Category" },
        { label: "Source", key: "Source" },
        { label: "date", key: "date" }
    ];

    const downloadCompetitorContacts = async (searchString = '', dateRange, source) => {
        try {
            if (localStorage.getItem("role") === roles.b2b) {
                setLoader(true);
                let res = await api({
                    url: `/competitor_data/downloadCompetitorData`,
                    method: "POST",
                    responseType: "json",
                    data: {
                        search: searchString,
                        dateRange,
                        source
                    }
                });
                if (res?.code !== 200) {
                    toast.error(res?.data?.message)
                } else {
                    setDownloadData(res?.data?.data);
                    setuserId(res?.data?.user_id);
                    setLoader(false);
                }
            }
        } catch (error) {
            setLoader(false);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    const sendRequest = async (contact_id) => {
        try {
            let res = await api({
                url: `/competitor_data/request/${contact_id}`,
                method: "POST",
                responseType: "json"
            });
            if (res.code === 200) {
                toast.success("Request sent Successfully");
                loadData('', 0, dateRange, source);
            } else {
                setRequestStatus(res.data.message)
                toast.error(res.data.message)
            }
        } catch (error) {
            let er = error?.response?.message || "Something went wrong"
            Toast("error", er)
            if (error.response.status === 401)
                navigate("/")
        }

    }

    const searchData = e => {
        setSearch(e.target.value);
        setCurrentPage(0);
        loadData(e.target.value, 0, dateRange, source);
        downloadCompetitorContacts(e.target.value, dateRange, source);
    }

    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    const handledelClose = () => {
        setDel(false)
    };

    const downloadUploadedFile = async (event) => {
        const file = event.target.files[0]
        if (event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            // Throw an error if the file type is not XLSX
            setFileUrl("")
            return;
        }
        const formData = new FormData();
        formData.append("files", event.target.files[0]);
        try {
            let url = await api({
                url: `/upload/birdviewFile`,
                method: "POST",
                responseType: "json",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (url.code === 200) {
                setFileUrl(url.data)
            } else {
                Toast("error", url.data.message);
            }
        } catch (error) {
            Toast("error", error);
        }
    }

    const {
        register,
        setValue,
        formState: { errors },
    } = useForm({ mode: "onSubmit" });

    const [file, setFile] = useState(null);
    const [jsonData, setJsonData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleFileUpload = async (event) => {
        setFile(event.target.files[0]);
        if (event.target.files[0]) {
            if (event.target.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                // Throw an error if the file type is not XLSX
                Toast('error', "Please upload file with .xlsx extension")
                return;
            }
            else {
                setIsLoading(true);
                try {
                    const arrayBuffer = await event.target.files[0].arrayBuffer();
                    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                    let sheetsCount = Object.keys(workbook.Sheets).length;

                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];

                    const customCellFormat = (cell, value) => {
                        if (cell.t === 'd' && typeof value === 'number') {
                            return new Date((value - (25567 + 1)) * 86400 * 1000); // Convert Excel serial date to JavaScript date
                        }
                        return value;
                    };

                    const convertedData = XLSX.utils.sheet_to_json(worksheet, {
                        raw: false, // Ensure that cell values are parsed
                        defval: '', // Provide a default value for empty cells
                        cellDates: true, // Enable cell date parsing
                        dateNF: 'DD/MM/YY', // Specify the date format
                        cellFormat: customCellFormat, // Use the custom cell format function

                    });
                    setJsonData(convertedData);
                    let response = await api({
                        url: `/competitor_data/uploadContactFile`,
                        method: "POST",
                        responseType: "json",
                        data: {
                            convertedData,
                            sheetsCount
                        }
                    })

                    if (response.code === 200) {
                        toast.success("Contacts added successfully");
                        loadData('', 0, dateRange, source)
                        downloadCompetitorContacts("", dateRange, source);
                        loadSources();
                        setFile(null)
                    } else {
                        toast.error(response?.data?.message);
                        loadData('', 0, dateRange, source)
                        downloadCompetitorContacts("", dateRange, source)
                        setFile(null);
                        loadSources();
                    }
                    downloadUploadedFile(event);
                    setIsLoading(false);
                } catch (error) {
                    console.error('Error converting Excel to JSON:', error);
                    setIsLoading(false);
                }
                setValue('file_xlsx', '')
            }
        }
        else {
            return
        }

    };

    const handleFileInputChange = (e) => {
        handleFileUpload(e);
        downloadUploadedFile(e);
    };

    const advData = async (contact_id) => {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
            setLoader(true);
            let response = await api({
                url: `/competitor_data/advDetails`,
                method: "POST",
                responseType: "json",
                data: {
                    contactId: contact_id
                }
            })
            if (response?.code !== 200) {
                toast.error(response?.data?.message);
                loadData(search, 0, dateRange, source);
            } else {
                setAdvDetails(response?.data?.result);
                setPreview(!preview);
                setLoader(false);
            }
        }

    }

    const handleConvert = async () => {
        if (!file) {
            return;
        }

        try {
            const arrayBuffer = await file.arrayBuffer();
            const workbook = XLSX.read(arrayBuffer, { type: 'array' });
            let sheetsCount = Object.keys(workbook.Sheets).length;
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const convertedData = XLSX.utils.sheet_to_json(worksheet);
            setJsonData(convertedData);
            let response = await api({
                url: `/competitor_data/uploadContactFile`,
                method: "POST",
                responseType: "json",
                data: {
                    convertedData,
                    sheetsCount
                }
            })
            if (response.code === 200) {
                toast.success("COntacts added successfully")
            } else {
                toast.error(response?.data?.message)
            }
        } catch (error) {
            console.error('Error converting Excel to JSON:', error);
        }
    };
    const downloadSampleExcel = () => {
        const wb = XLSX.utils.book_new();
        const wsData = [['Name', 'Designation', 'Official_Email', 'Personal_Email', 'Mobile', 'Company_Name', 'Location', 'Category', 'Source', 'date', 'Image_Url']]; // Column names
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, ws, 'SampleSheet');
        XLSX.writeFile(wb, 'SampleCompetitorData.xlsx'); // Download the file
    };
    let formik = useFormik({
        initialValues: JSON.parse(JSON.stringify(initialContacts)),
        validationSchema: ContactsSchema,
        onSubmit: async (values) => {
            if (flag === 'add') {
                try {
                    let res = await api({
                        url: `/competitor_data/add`,
                        method: "POST",
                        responseType: "json",
                        data: values
                    });
                    if (res?.code !== 200) {
                        Toast('error', res?.data?.message);
                    } else {
                        Toast("success", "Contact Added Successfully");
                        handleClose();
                        setCurrentPage(0);
                        setSearch('');
                        setFlag('')
                        loadData(search, 0, dateRange, source);
                        downloadCompetitorContacts(search, dateRange, source);
                        loadSources();
                    }
                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
            if (flag === 'edit') {
                try {
                    let res = await api({
                        url: `/competitor_data/edit/${id}`,
                        method: "PUT",
                        responseType: "json",
                        data: values
                    });
                    if (res?.code === 200) {
                        Toast("success", "Contact updated Successfully");
                        handleClose();
                        setFlag('');
                        setCurrentPage(0);
                        loadData(search, 0, dateRange, source);
                        downloadCompetitorContacts(search, dateRange, source);
                        loadSources();
                        values.name = ''
                        values.designation = ''
                        values.official_email = ''
                        values.personal_email = ''
                        values.mobile = ''
                        values.company = ''
                        values.location = ''
                        values.category = ''
                        values.source = ''
                        values.date = ''
                        values.image_url = ''
                    } else {
                        Toast('error', res?.data?.message);

                    }

                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
        }
    });
    const handleNextClick = async () => {
        if (clickindex === data?.length - 1) {
            if (currentPage < Math.ceil(totalRecords / 100)) {
                if (currentPage !== 0) {
                    await loadMoreData(currentPage + 1);
                } else {
                    loadMoreData(((data?.length) / 100));
                }
            }
        }

    };

    const handlePrevClick = () => {
        if (currentPage > 0) {
            loadPrevData(currentPage - 1);
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    const loadMoreData = async (page) => {
        try {
            setLoader(true);
            setIsLoading(true)
            let res = await api({
                url: `/competitor_data/get`,
                method: "POST",
                responseType: "json",
                data: {
                    page,
                    limit: 10,
                    search: search,
                    dateRange
                },
            });
            if (res?.code === 200) {
                setData((prevData) => [...prevData, ...res.data.data]);
                setLoader(false);
                setIsLoading(false);
            }
        } catch (error) {
            setLoader(false);
            if (error?.response?.status === 401) navigate("/");
        }
    };

    const loadPrevData = async (page) => {
        try {
            setLoader(true);
            setIsLoading(true);
            let res = await api({
                url: `/competitor_data/get`,
                method: "POST",
                responseType: "json",
                data: {
                    page,
                    limit: 10,
                    search: search,
                    dateRange
                },
            });
            if (res?.code === 200) {
                setClickIndex(res.data.data?.length);
                setData((prevData) => [...res.data.data, ...prevData]);
                setLoader(false);
                setIsLoading(false);
            } else {
                console.error(res?.data?.message)
            }
        } catch (error) {
            setLoader(false);
            if (error?.response?.status === 401) navigate("/");
        }
    };

    const [scrolltopdata, setscrolltopdata] = useState('');

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.scrollY < 15) {
                setscrolltopdata('');
            } else {
                setscrolltopdata('scrolled');
            }
        });
    }, [])

    return (
        <>
            <SlDrawer label="Are you sure!" open={del} onSlRequestClose={handleRequestClose} onSlAfterHide={handledelClose} style={{ '--size': '30vw' }}>
                {/* <p><span style={{ fontFamily: "Arial", fontWeight: "bold" }}>{delname}</span> will be deleted</p> */}
                <p><span style={{ fontFamily: "Arial", fontWeight: "bold" }}>Selected Contacts</span> will be deleted</p>

                <div className='d-flex gap-2'>
                    <Button variant="success" onClick={() => setDel(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={async () => { setDel(false); await deleteContact(selectedRecords); setSelectAll(false); setSelectedRecords([]) }}>Confirm</Button>
                </div>
            </SlDrawer>
            <div className={`flex gap-4 justify-end mb-4 stickyFilters ${scrolltopdata}`}>
            {localStorage.getItem("role") === roles.b2b ? (< div className="flex justify-end">
                    {selectedRecords.length > 0 && (
                        <SlButton variant="primary" size="small" onClick={async () => { setDel(true) }}>Delete Selected</SlButton>
                    )}
                </div>
                ) : null}
                <div className='d-flex gap-4 mobHide'>

                <div>
                    <SlSelect
                        className='w-full'
                        placeholder="Select Source"
                        name="source"
                        size="medium"
                        value={source}
                        // onSlChange={(e) => dispatch(SetBirdViewSource(e.target.value))}
                        onSlChange={(e) => { setSource(e.target.displayLabel); setSearch(""); setData([]); setCurrentPage(0) }}

                    >
                        {/* <SlIcon library="lucide" name="source" slot="prefix"></SlIcon> */}

                        <SlOption key={0} value={'All'}>All</SlOption>
                        {sources?.map(item => (
                            <SlOption key={item.source} value={item.source}>
                                {item.source}
                            </SlOption>
                        ))}

                    </SlSelect>
                </div>

                <SlInput size="medium" id="myInput" value={search} onSlInput={(e) => { setSearch(e.target.value); setData([]); setCurrentPage(0) }} placeholder="Search By Name/ Company / Category / Location / Designation" >
                    <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>

                {/* <div>
                    <SlInput className='w-full' size='medium' type="date" placeholder="Date"
                        // onSlInput={(e) => dispatch(SetBirdViewDate(e.target.value))} style={{ width: '230px' }}
                        onSlInput={(e) => { setDateFilter(e.target.value) }}

                    />
                </div> */}

                <div className='border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500'>
                    <Datepicker
                        classNames="form-input"
                        value={dateRange}
                        primaryColor={"cyan"}
                        showShortcuts={true}
                        useRange={true} // Allow date range selection
                        configs={{
                            shortcuts: {
                                today: "today",
                                yesterday: "yesterday",
                                currentMonth: "currentMonth",
                                pastMonth: "lastMonth",

                            }
                        }}
                        onChange={handleDateRange}
                    />
                </div>
                </div>
                <img src={filterSvg} alt='filter' className='w-6 mobileOnly ' onClick={() => {setShowFilter(true)}}></img>
                {(localStorage.getItem("role") === roles.b2b) ? (<div className="moreOptions">
                    {(localStorage.getItem("role") === roles.b2b) ? (<div>
                        <label className="m-0">
                            <i className="bi bi-download px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Download Sample File" onClick={downloadSampleExcel}></i>
                        </label>
                    </div>) : null}

                    {(localStorage.getItem("role") === roles.b2b) ? (<div className="d-flex">
                        <CSVLink
                            data={downloadData}
                            headers={csvHeaders}
                            filename={`Competitor_contacts.csv`}
                        >
                            <i className="bi bi-download px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Download Birdview Data"></i>
                            {/* <sl-icon-button
                            library="lucide"
                            title="Download Data"
                            name="download"
                        ></sl-icon-button> */}
                        </CSVLink>
                    </div>) : null}

                    {(localStorage.getItem("role") === roles.b2b) ? (<div className='d-flex'>
                        <label htmlFor="file" className="m-0">
                            <i className="bi bi-arrow-up-circle px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Upload Contacts File"></i>
                            <input type="file" id="file" style={{ display: "none" }} name="file"
                                {...register("file_xlsx", {
                                    required: false,
                                    onChange: (e) => handleFileUpload(e),
                                })} />
                        </label>

                        {isLoading ? (
                            <div className="loader">
                                <div className="spinner-border text-primary" role="status"  >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : null}
                    </div>) : null}
                </div>) : null}

                {(localStorage.getItem("role") === roles.b2b) ? (<SlButton size="small" variant="primary" onClick={() => { handleShow("add", initialContacts); setFlag('add') }}>Add Contact</SlButton>) : null}
            </div >
            <SlDrawer label="Create Contact" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                        <label className="mb-1"> Name</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            aria-label=""
                            name="name"
                            value={formik.values.name}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.name ? (
                            <div className="text-red-600">{formik.errors.name}</div>
                        ) : null}
                    </div>
                    {/* <div className="mb-3" >
                        <label className="mb-1"> Designation</label>
                        <input
                            className="form-control"
                            type='text'
                            name='designation'
                            placeholder='Enter Designation'
                            aria-label=""
                            value={formik.values.designation}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.designation ? (
                            <div className="text-red-600">{formik.errors.designation}</div>
                        ) : null}
                    </div> */}
                    {/* <div className="mb-3" >
                        <label className="mb-1">Official Email</label>
                        <input
                            type='email'
                            className="form-control"
                            placeholder='Enter Official Email'
                            name='official_email'
                            aria-label=""
                            value={formik.values.official_email}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.official_email ? (
                            <div className="text-red-600">{formik.errors.official_email}</div>
                        ) : null}
                    </div>
                    <div className="mb-3" >
                        <label className="mb-1">Personal Email</label>
                        <input
                            type='email'
                            className="form-control"
                            placeholder='Enter Personal Email'
                            name='personal_email'
                            aria-label=""
                            value={formik.values.personal_email}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.personal_email ? (
                            <div className="text-red-600">{formik.errors.personal_email}</div>
                        ) : null}
                    </div> */}
                    {/* <div className="mb-3" >
                        <label className="mb-1"> Mobile No</label>
                        <input
                            className="form-control"
                            type='tel'
                            name='mobile'
                            placeholder='Enter Mobile No'
                            aria-label=""
                            value={formik.values.mobile}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.mobile ? (
                            <div className="text-red-600	">{formik.errors.mobile}</div>
                        ) : null}
                    </div> */}
                    {/* <div className="mb-3" >
                        <label className="mb-1"> Company Name</label>
                        <input
                            className="form-control"
                            type='text'
                            name='company'
                            placeholder='Enter Company Name'
                            aria-label=""
                            value={formik.values.company}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.company ? (
                            <div className="text-red-600">{formik.errors.company}</div>
                        ) : null}
                    </div> */}
                    <div className="mb-3">
                        <label className="mb-1">Company Name</label><span className="text-red-600">*</span>
                        <Select
                            // className="form-select"
                            options={brands}
                            name="company"
                            onBlur={formik.handleBlur}
                            onChange={(option) => formik.setFieldValue('company', option ? option.value : '')}
                            value={brands?.find(option => option.value === formik.values.company)}
                        />
                        {submit && formik.errors.company ? (
                            <div className="text-red-600">{formik.errors.company}</div>
                        ) : null}
                    </div>
                    {/* <div className="mb-3" >
                        <label className="mb-1"> Location</label>
                        <input
                            className="form-control"
                            type='text'
                            name='location'
                            placeholder='Enter location'
                            aria-label=""
                            value={formik.values.location}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.location ? (
                            <div className="text-red-600	">{formik.errors.location}</div>
                        ) : null}
                    </div> */}
                    {/* <div className="mb-3" >
                        <label className="mb-1"> Category</label>
                        <input
                            className="form-control"
                            type='text'
                            name='category'
                            placeholder='Enter Category'
                            aria-label=""
                            value={formik.values.category}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.category ? (
                            <div className="text-red-600">{formik.errors.category}</div>
                        ) : null}
                    </div> */}
                    <div className="mb-3" >
                        <label className="mb-1"> Source</label><span className="text-red-600">*</span>
                        <input
                            className="form-control"
                            type='text'
                            name='source'
                            placeholder='Enter Source'
                            aria-label=""
                            value={formik.values.source}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {submit && formik.errors.source ? (
                            <div className="text-red-600">{formik.errors.source}</div>
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <label>Date</label><span className="text-red-600">*</span>
                        <input
                            type="date"
                            name="date"
                            className="form-control"
                            placeholder="Choose Date"
                            aria-label=""
                            value={formik.values.date}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {
                            submit && formik.errors.date ? (
                                <div className="text-red-600	">{formik.errors.date}</div>
                            ) : null
                        }
                    </div>
                    <div>
                        <label>Image Link</label>
                        <input
                            type="url"
                            name="image_url"
                            className="form-control"
                            placeholder="Enter the Image Link"
                            aria-label=""
                            value={formik.values.image_url}
                            onBlur={formik.handleBlur}
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                        />
                        {
                            submit && formik.errors.image_url ? (
                                <div className="text-red-600	">{formik.errors.image_url}</div>
                            ) : null
                        }
                    </div>

                    <div slot="footer">
                        <SlButton
                            type="submit"
                            variant="primary"
                            size="small"
                            onClick={(e) => setSubmit(true)}>Submit</SlButton>
                    </div>

                </form>
            </SlDrawer>
            < div className='mb-4' >
                <table className='table table-bordered'>
                    {/* <thead className="sticky top-0 ">
                        <tr>
                            {(localStorage.getItem("role") === roles.b2b) ? (<th>
                                <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={toggleSelectAll}
                                />
                            </th>) : null}
                            <th >Brand Name</th>
                            <th>Designation</th>
                            <th >Official Email</th>
                            <th >Personal Email</th>
                            <th >Mobile</th>
                            {(localStorage.getItem("role") === roles.salesperson) ? (<th>Expiry Date</th>) : null}
                            <th >Company Name</th>
                            <th>Location</th>
                            <th>Category</th>
                            <th>Date</th>
                            <th>Image</th>
                            <th>Drive Link Image</th>
                            {(localStorage.getItem("role") === roles.b2b) ? (<th>Source</th>) : null}
                            <th>Actions</th>
                        </tr>
                    </thead> */}
                    {/* {(data?.length && !loader) ? (
                        <tbody>
                            {data.map((item, index) => {
                                return (
                                    <tr key={item.contact_id} className="group/details hover:bg-slate-100">
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>
                                            <input
                                                type="checkbox"
                                                checked={selectedRecords.includes(item.contact_id)}
                                                onChange={() => toggleCheckbox(item.contact_id)}
                                            />
                                        </td>) : null}
                                        <th scope='row' >{((item.name === "null") ? ("-") : (item.name))}</th>
                                        <td>{((item.designation === "null") ? ("-") : (item.designation))}</td>
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>{((item.official_email === "null") ? ("-") : (item.official_email))}</td>) : <td>{item.official_email || '-'}</td>}
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>{item.personal_email || '-'}</td>) : <td>{item.personal_email || '-'}</td>}
                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>{item.mobile || '-'}</td>) : <td>{item.mobile || '-'}</td>}
                                        {<td>{item.official_email || 'xxxxxxxxxx@gmail.com'}</td>}
                                        <td>{item.personal_email || 'xxxxxxxxxx@gmail.com'}</td>
                                        <td>{item.mobile || '+91xxxxxxxxxx'}</td>
                                        {(localStorage.getItem("role") === roles.salesperson) ? (<td>{(item.expiry) ? (formatDate(item.expiry)) : "-"}</td>) : null}
                                        <td>{item.company || '-'}</td>
                                        <td>{item.location || '-'}</td>
                                        <td>{item.category || '-'}</td>
                                        <td>{formatDate(item.date) || '-'}</td>
                                        <td>{(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) ? (
                                            (item.image_url ? (<div>
                                                <sl-tooltip content="View Image">
                                                    <sl-icon-button
                                                        library="lucide"
                                                        name="image"
                                                        onClick={async () => { setId(item.contact_id); await imageData(item.contact_id); }}
                                                    ></sl-icon-button>
                                                </sl-tooltip>


                                            </div>) : "-"))
                                            : null}</td>

                                        <td>{(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) ? (
                                            (item.image_drive_link ? (<div>
                                                <sl-tooltip content="View Drive Link Image">
                                                    <sl-icon-button
                                                        library="lucide"
                                                        name="image"
                                                        onClick={async () => { setId(item.contact_id); await driveImageData(item.contact_id); }}
                                                    ></sl-icon-button>
                                                </sl-tooltip>


                                            </div>) : "-"))
                                            : null}</td>

                                        {(localStorage.getItem("role") === roles.b2b) ? (<td>{item.source}</td>) : null}
                                        {(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) ? (<td >
                                            <div className='inline-flex gap-3'>
                                                {(localStorage.getItem("role") === roles.b2b) ? (< SlTooltip content="Edit Contact">
                                                    <SlIconButton
                                                        library="lucide"
                                                        name="edit"
                                                        onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.contact_id) }}></SlIconButton>
                                                </SlTooltip>) : null}

                                                {(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) ? (
                                                    <sl-tooltip content="View Data">
                                                        <sl-icon-button
                                                            library="lucide"
                                                            name="eye"
                                                            onClick={async () => { setClickIndex(index); handleOpen() }}
                                                        ></sl-icon-button>
                                                    </sl-tooltip>) : null}

                                            </div>
                                        </td>) : null}
                                    </tr>
                                )
                            })}
                        </tbody>) : ((!data?.length && !loader)
                            ? <NoDataFound colspan="8" />
                            : <TableLoader colspan="8" />
                    )
                    } */}

                    <body>
                        <InfiniteScroll
                            dataLength={data?.length}
                            next={() => {
                                setCurrentPage(prevPage => prevPage + 1); loadData(search,
                                    currentPage + 1,
                                    dateRange, source)
                            }}
                            hasMore={data?.length < totalRecords}
                            loader={<TableLoader colspan={3} />}
                        >
                            {data?.length && !loader ? (
                                <div class="birdviewWrapper">
                                    {/* <div class="radioGroup select-all">
                                        <input
                                            id="selectAll"
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={toggleSelectAll}
                                        />
                                        <label for="selectAll"></label>
                                    </div> */}

                                    <ul class="birdview">
                                        {data.map((item, index) => {
                                            return (
                                                <li>
                                                    <div class="theme">
                                                        {(item?.image_url) ? (<img src={item.image_url} alt="Image" />) : (<img src={NoImage} alt="Image" />)}
                                                        <div class="blur"> {(item?.image_url) ? (<img src={item.image_url} alt="Image" />) : (<img src={NoImage} alt="Image" />)}</div>
                                                        <div class="publisher">
                                                            {(item?.source) ? (<h6 class="eenadu">{item.source}</h6>) : null}                                                        </div>
                                                        <p className="location"><img src={LocationSVG} alt="location_name" title={item.location} />{item.location}</p>
                                                        {/* Selcter CheckBox */}
                                                        {/* {(localStorage.getItem("role") === roles.b2b) ? (<div class="radioGroup">
                                                            <input type="checkbox" id={item.id} checked={selectedRecords.includes(item.contact_id)}
                                                                onChange={() => toggleCheckbox(item.contact_id)} />
                                                            <label for={item.contact_id}></label>
                                                        </div>) : null} */}
                                                        {item.image_url ? (<Button className="previewBtn" variant="neutral" onClick={() => { setImgSrc(item.image_url); setView(true) }}>
                                                            Preview
                                                        </Button>) : null}
                                                    </div>
                                                    <div class="description">
                                                        {(<p>Date : {formatDate(item.date)}</p>)}
                                                        <h1>{item.name || "   "}</h1>
                                                    </div>

                                                    <div class="moreOptions">
                                                        {(localStorage.getItem("role") === roles.b2b) ? (<div class="option"

                                                            onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.contact_id) }}

                                                        >
                                                            <img src={EditIcon} alt="" />
                                                            <h6>Edit</h6>
                                                        </div>) : null}
                                                        <div class="option" onClick={async () => {
                                                            setId(item.contact_id);
                                                            await advData(item.contact_id)
                                                        }}>
                                                            <img src={UserIcon} alt="" />
                                                            <h6>Advertisers</h6>
                                                        </div>
                                                    </div>
                                                </li>)
                                        })}
                                    </ul>
                                </div>
                            ) : !data?.length && !loader ? (
                                <NoDataFound colspan="17" />
                            ) : (
                                <div class="d-flex justify-content-center">
                                    <div class="spinner-border" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            )}
                        </InfiniteScroll>
                    </body >
                </table>
            </div >
            {/* <div className="flex justify-end"> {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}</div> */}
            {/* <SlDrawer
                label={"Preview"}
                open={open}
                onSlRequestClose={handleRequestClose}
                onSlAfterHide={async () => { setOpen(false); setClickIndex(-1); setCurrentPage(0); loadData(search, 0, dateRange, source); }}
                style={{ "--size": "100vw" }}
            >
                <div className="card">
                    <div className="card-header">
                        <div className="flex items-center gap-3" style={{ paddingBottom: "10px" }}>
                            <div className="fixed-button left">
                                <SlButton
                                    disabled={(currentPage === 0 && clickindex === 0) || data?.length === 0 ? true : false}
                                    onClick={() => {
                                        setClickIndex((prevIndex) => prevIndex - 1);
                                        if (clickindex === 0) {
                                            handlePrevClick();
                                        }
                                    }}
                                    variant="neutral"
                                >
                                    Prev
                                </SlButton>
                            </div>
                            <aside className="flex items-center gap-3 ml-20">

                                <div className="flex-1" style={{ marginRight: "10px" }}>

                                    <div className="card" style={{ marginBottom: "10px" }}>

                                        <div className="card-header">
                                            {isLoading ? (
                                                <div className="loader">
                                                    <div className="spinner-border text-primary" role="status"  >
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            ) : ((data[clickindex]?.image_url) ? (<img src={data[clickindex].image_url} alt="Image" style={{ width: "700px", height: "600px" }} />) : <NoDataFound />)}

                                        </div>
                                    </div>
                                </div>


                                <div className="flex-1" style={{ marginLeft: "10px" }}>

                                    <p style={{ whiteSpace: "nowrap" }}><strong>Brand Name : </strong>{(data[clickindex]?.name) ? ((data[clickindex]?.name === "null") ? " " : data[clickindex]?.name) : " "}</p>
                                    <p style={{ whiteSpace: "nowrap" }}><strong>Designation : </strong>{(data[clickindex]?.designation) ? ((data[clickindex]?.designation === "null") ? " " : data[clickindex]?.designation === "null") : " "}</p>
                                    <p style={{ whiteSpace: "nowrap" }}><strong>Official Email : </strong>{(data[clickindex]?.official_email) ? ((data[clickindex]?.official_email === "null") ? " " : data[clickindex]?.official_email) : " "}</p>
                                    <p style={{ whiteSpace: "nowrap" }}><strong>Personal Email : </strong>{(data[clickindex]?.personal_email) ? (data[clickindex]?.personal_email) : " "}</p>
                                    <p style={{ whiteSpace: "nowrap" }}><strong>Mobile No : </strong>{(data[clickindex]?.mobile) ? (data[clickindex]?.mobile) : " "}</p>
                                    <p style={{ whiteSpace: "nowrap" }}><strong>Date : </strong>{(data[clickindex]?.date) ? (formatDate(data[clickindex]?.date)) : " "}</p>
                                    <p style={{ whiteSpace: "nowrap" }}><strong>Location : </strong>{(data[clickindex]?.location) ? (data[clickindex]?.location) : " "}</p>
                                    <p style={{ whiteSpace: "nowrap" }}><strong>Category : </strong>{(data[clickindex]?.category) ? (data[clickindex]?.category) : " "}</p>
                                    <p style={{ whiteSpace: "nowrap" }}><strong>Company : </strong>{(data[clickindex]?.company) ? (data[clickindex]?.company) : " "}</p>
                                    {(localStorage.getItem("role") === roles.b2b) ? (<p style={{ whiteSpace: "nowrap" }}><strong>Category : </strong>{(data[clickindex]?.source) ? (data[clickindex]?.source) : " "}</p>) : null}

                                </div>
                            </aside>
                            <div className="fixed-button right">
                                <SlButton
                                    disabled={
                                        (clickindex === data?.length - 1 && currentPage === Math.ceil(totalRecords / 100) - 1) || data?.length === 0 ? true
                                            : false
                                    }
                                    onClick={() => {

                                        setClickIndex((prevIndex) => prevIndex + 1);
                                        handleNextClick();
                                    }}
                                    variant="neutral"
                                >
                                    Next
                                </SlButton>
                            </div>
                        </div>
                    </div>
                </div >
            </SlDrawer > */}
            {/* <Modal className="birdview-image-preview" show={view} onHide={() => setView(false)}>
                <Modal.Header closeButton>Image Preview
                </Modal.Header>
                <Modal.Body>
                    <img src={imgSrc} alt="" />
                </Modal.Body>
            </Modal > */}
    <Modal 
          className="birdview-image-preview" 
          show={view} 
          onHide={() => setView(false)}
          size="xl"
        >
            <Modal.Header closeButton>
            <span className="text-base font-medium">Image Preview - Complete Edge Coverage</span>
            </Modal.Header>
            <Modal.Body className="p-0">
            <div className="grid grid-cols-1 lg:grid-cols-6 gap-0">
                {/* Original Image */}
                <div className="lg:col-span-3 p-6 bg-gray-50">
                <div
                    className="relative bg-white rounded-lg shadow-lg p-2"
                    onMouseEnter={() => setShowMagnifier(true)}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={() => setShowMagnifier(false)}
                >
                    <img 
                    ref={imgRef}
                    src={imgSrc} 
                    alt="" 
                    className="w-full h-auto block rounded cursor-crosshair"
                    />
                </div>
                </div>

                {/* Zoomed Panel - Shows ALL edges clearly */}
                <div className="lg:col-span-3 p-6 bg-gray-100 border-l border-gray-300">
                <div className="sticky top-4 bg-white rounded-lg shadow-xl">
                    <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 py-3 rounded-t-lg">
                    <div className="flex items-center justify-between">
                        <span className="font-semibold">🔍 Zoomed View</span>
                        <span className="bg-white bg-opacity-20 px-2 py-1 rounded text-xs">
                        {zoomLevel}x
                        </span>
                    </div>
                    <p className="text-xs text-blue-100 mt-1">Hover anywhere - including edges</p>
                    </div>
                    
                    {showMagnifier ? (
                    <div 
                        className="w-full h-96 rounded-b-lg overflow-hidden"
                        style={{
                        backgroundImage: `url(${imgSrc})`,
                        backgroundPosition: `${position.x}% ${position.y}%`,
                        backgroundSize: `${zoomLevel * 100}%`,
                        backgroundRepeat: 'no-repeat',
                        imageRendering: '-webkit-optimize-contrast',
                        filter: 'contrast(1.1)',
                        }}
                    />
                    ) : (
                    <div className="w-full h-96 rounded-b-lg flex items-center justify-center bg-gray-50">
                        <div className="text-center">
                        <div className="text-4xl mb-2">👆</div>
                        <p className="text-gray-500 text-sm">Hover over image</p>
                        <p className="text-gray-400 text-xs mt-1">to see zoomed view</p>
                        </div>
                    </div>
                    )}
                </div>
                </div>
            </div>
            </Modal.Body>
    </Modal>

            <SlDrawer
                label={"Advertiser Details"}
                open={preview}
                onSlRequestClose={handleRequestClose}
                onSlAfterHide={() => { setPreview(false); setId("") }}
                style={{ "--size": "70vw" }}
            >
                <div className="flex justify-end mb-5">
                </div>
                <div className="overflow-x-auto">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Officail Email</th>
                                <th>Personal Email</th>
                                <th>Mobile Number</th>
                                <th>Company</th>
                            </tr>
                        </thead>
                        {advDetails?.length && !loader ? (
                            <tbody>
                                {advDetails.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {(item.name) ? (<td>{item.name}</td>) : (<td>{"NA"}</td>)}
                                            {(item.designation === "null") ? (<td>{"NA"}</td>) : (<td>{item.designation}</td>)}
                                            {(item.official_email === "null") ? (<td>{"NA"}</td>) : (<td>{item.official_email}</td>)}
                                            {(item.personal_email) ? (<td>{item.personal_email}</td>) : (<td>{"NA"}</td>)}
                                            {(item.mobile) ? (<td>{item.mobile}</td>) : (<td>{"NA"}</td>)}
                                            {(item.company) ? (<td>{item.company}</td>) : (<td>{"NA"}</td>)}

                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : !advDetails?.length && !loader ? (
                            <NoDataFound colspan="8" />
                        ) : (
                            <TableLoader colspan="8" />
                        )}
                    </table>
                </div>
            </SlDrawer>
            <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={()=>{}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
        <h3 className="mb-3">Apply Filters</h3>
        <hr></hr>
        <div className='d-flex gap-4 flex-wrap'>


                <div className='w-full'>
                    <SlSelect
                        className='w-full'
                        placeholder="Select Source"
                        name="source"
                        size="medium"
                        value={source}
                        // onSlChange={(e) => dispatch(SetBirdViewSource(e.target.value))}
                        onSlChange={(e) => { setSource(e.target.displayLabel); setSearch(""); setData([]); setCurrentPage(0) }}

                    >
                        {/* <SlIcon library="lucide" name="source" slot="prefix"></SlIcon> */}

                        <SlOption key={0} value={'All'}>All</SlOption>
                        {sources?.map(item => (
                            <SlOption key={item.source} value={item.source}>
                                {item.source}
                            </SlOption>
                        ))}

                    </SlSelect>
                </div>

                <SlInput size="medium" className='w-full' id="myInput" value={search} onSlInput={(e) => { setSearch(e.target.value); setData([]); setCurrentPage(0) }} placeholder="Search By Name/ Company / Category / Location / Designation" >
                    <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>

                {/* <div>
                    <SlInput className='w-full' size='medium' type="date" placeholder="Date"
                        // onSlInput={(e) => dispatch(SetBirdViewDate(e.target.value))} style={{ width: '230px' }}
                        onSlInput={(e) => { setDateFilter(e.target.value) }}

                    />
                </div> */}

                <div className='border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-full'>
                    <Datepicker
                        classNames="form-input"
                        value={dateRange}
                        primaryColor={"cyan"}
                        showShortcuts={true}
                        useRange={true} // Allow date range selection
                        configs={{
                            shortcuts: {
                                today: "today",
                                yesterday: "yesterday",
                                currentMonth: "currentMonth",
                                pastMonth: "lastMonth",

                            }
                        }}
                        onChange={handleDateRange}
                    />
                </div>
                </div>
        <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
        </>
    )
}
export default CompetitorData